// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"lazysizes":"c93a43cd6b9efe37c4d2","flickity":"d5c7a3d87ba65f3f03a7","axios":"66927a042470982ad76c"}[chunkId] + ".js";
};